export class PageBlockFAQ {
    public blockTitle = null;
    public id = null;
    public imageUrl = null;
    public removeFromNav = null;
    public slides = null;
    public text = null;
    public type = null;

    public faq = null;

    constructor(pageBlockFAQ) {
        this.blockTitle = pageBlockFAQ.blockTitle;
        this.id = pageBlockFAQ.id;
        this.imageUrl = pageBlockFAQ.imageUrl;
        this.removeFromNav = pageBlockFAQ.removeFromNav;
        this.slides = pageBlockFAQ.slides;
        this.text = pageBlockFAQ.text;
        this.type = pageBlockFAQ.type;

        this.faq = pageBlockFAQ.faq.map(faqElement => { 
            return new FAQElement(faqElement);
        });
    }

    getMenuElement(url, index) {
        return {
            href: url + '#faq-' + index,
            name: this.blockTitle.replace(/<[^>]*>/g, '')
        }
    }
}

export class FAQElement {
    public answer = null;
    public question = null;

    constructor(faqElement) {
        this.answer = faqElement.answer;
        this.question = faqElement.question;
    }
}